import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import type { FC } from "react";

/** "Are you sure?" before archiving or unarchiving, as a Communication's card asks it. */
export const ArchiveDialog: FC<{
  open: boolean;
  onClose: () => void;
  /** What's archived, e.g. "Communication". */
  kind: string;
  unarchive?: boolean;
  archiving?: boolean;
  onConfirm: () => void;
  /** Prefixes the buttons' analytics ids. */
  analyticsId: string;
}> = ({ open, onClose, kind, unarchive = false, archiving = false, onConfirm, analyticsId }) => {
  const verb = unarchive ? "unarchive" : "archive";

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        {unarchive ? "Unarchive" : "Archive"} {kind}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to {verb} this {kind}?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          data-analytics-id={`${analyticsId}-${verb}-dialog-cancel`}
          onClick={onClose}
          disabled={archiving}
        >
          Cancel
        </Button>
        <Button
          data-analytics-id={`${analyticsId}-${verb}-dialog-confirm`}
          loading={archiving}
          variant="contained"
          onClick={onConfirm}
        >
          Yes, I’m sure
        </Button>
      </DialogActions>
    </Dialog>
  );
};
